import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './chat.mutations';
import actions from './chat.actions';

Vue.use(Vuex);

export default {
  namespaced: true,
  mutations,
  actions,
  state: {
    messages: [],
    listenerHandlerId: 'ABCDEFGHIJK'
  },
  getters: {}
};
